<div class="container">

    <div class="items-list">
        <div class="cnt pb-3">
            <form [formGroup]="form">
                <!-- Quiz List  -->
                <div id="accordion" formArrayName="quiz_lists">
                    <div class="card mb-1 acd-title" *ngFor="let quiz of quizLists().controls; let i = index"
                        [formGroupName]="i">
                        <span *ngIf="!quiz.get('is_input').value" class="ml-3">{{ i + 1 }}</span>
                        <div class="card-header" [id]="'heading' + i">

                            <!-- Quiz Question Input Area -->
                            <textarea rows="5" *ngIf="quiz.get('is_input').value" nz-input formControlName="name"
                                placeholder="Enter question"></textarea>


                            <div [ngClass]="{
                            'row align-items-center': !quiz.get('is_input').value
                          }">
                                <div [ngClass]="{ col: !quiz.get('is_input').value }">
                                    <!-- Quiz Questions   -->
                                    <h5 class="mb-0 d-flex align-items-center" data-toggle="collapse"
                                        [attr.data-target]="'#collapse' + i"
                                        [attr.aria-expanded]="i == 0 ? true : false"
                                        [attr.aria-controls]="'collapse' + i">
                                        <!-- <span class="mr-3">{{ i + 1 }}</span> -->
                                        <span *ngIf="!quiz.get('is_input').value">{{ quiz.get('name').value }}
                                            <span *ngIf="quiz.get('questionnaireType').value === 'single'"
                                                class="text-muted">
                                                ( အဖြေမှန် တစ်ခုသာ ရွေးပါ )</span>
                                            <span *ngIf="quiz.get('questionnaireType').value === 'multiple'"
                                                class="text-muted">
                                                ( အဖြေမှန်တစ်ခုမက ရွေးနိုင်သည် )</span>
                                        </span>
                                    </h5>
                                </div>

                                <!-- Quiz Save -->
                                <div [ngClass]="{
                              'ml-auto mr-3': !quiz.get('is_input').value,
                              'card-option pt-0 ml-auto acd-action':
                                quiz.get('is_input').value
                            }">

                                    <button *ngIf="!quiz.get('is_input').value" nz-button nzType="link"
                                        (click)="doEdit(i, quiz.value)">
                                        <i nz-icon nzType="edit"></i>
                                    </button>

                                    <button *ngIf="quiz.get('is_input').value" (click)="onSubmit(i)" nz-button
                                        nzType="link">
                                        <i nz-icon nzType="save"></i>
                                    </button>
                                    <button *ngIf="quiz.get('is_input').value" nzDanger
                                        (click)="doCancel(i, quiz.value.questionnaire)" nz-button nzType="link">
                                        <i nz-icon nzType="delete"></i>
                                    </button>
                                    <div *ngIf="quiz.get('name').touched && quiz.get('name').errors"
                                        class="ant-form-item-explain ant-form-item-explain-error">
                                        <div class="ant-form-item-explain-error">
                                            <span *ngIf="quiz.get('name').errors?.required">
                                                This field is required
                                            </span>
                                            <span *ngIf="quiz.get('name').errors?.minlength">
                                                Minimum length is {{
                                                quiz.get('name').errors?.minlength.requiredLength }}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="card-header" *ngIf="quiz.get('is_input').value || imageList[i]">
                            <div class="upload-wrapper">
                                <nz-upload class="avatar-uploader" nzName="avatar" nzListType="picture-card"
                                    [nzShowUploadList]="false" nzLimit="5120"
                                    [nzBeforeUpload]="beforeUpload.bind(this, i)" (nzChange)="handleChange($event,i)"
                                    nzFileType="image/png,image/jpeg" [nzDisabled]="!quiz.get('is_input').value">
                                    @if (!imageList[i]) {
                                    <span class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></span>
                                    <div class="ant-upload-text">Upload</div>
                                    } @else {
                                    <!-- [nzDisablePreview]="!field.readonly" -->
                                    <img nz-image style="width: 100%;object-fit: contain;height: 100%;"
                                        [nzSrc]="imageList[i]" alt="" [nzDisablePreview]="true" />
                                    }
                                    <span *ngIf="imageList[i] && quiz.get('is_input').value" (click)="deleteImage($event,i)" class="center-text"
                                        nz-icon [nzType]="'delete'"></span>
                                </nz-upload>
                            </div>
                            <input [hidden]="true" nz-input formControlName="image" />
                        </div>

                        <div [id]="'collapse' + i" class="collapse show" [attr.aria-labelledby]="'heading' + i"
                            data-parent="#accordion">
                            <div class="card-body pl-5" formArrayName="questionnaire">
                                <!-- Questions -->
                                <div *ngFor="
                              let ques of quiz.get('questionnaire')['controls'];
                              let j = index
                            ">
                                    <div [formGroupName]="j">
                                        <!-- Question Form -->
                                        <ng-container *ngIf="ques.get('is_input').value">
                                            <!-- <div class="row align-items-center justify-content-start mt-2"> -->
                                            <div class="option">
                                                <input class="form-check-input mt-2" [type]="
                                          quiz.get('questionnaireType').value === 'single'
                                            ? 'radio'
                                            : 'checkbox'
                                        " [checked]="ques.get('correct').value ? true : false" (change)="
                                          questionCheck(
                                            $event,
                                            i,
                                            j,
                                            quiz.get('questionnaireType').value
                                          )
                                        " formControlName="correct" />
                                                <!-- </div> -->
                                                <div class="pl-text-input">
                                                    <input type="text" class="form-control"
                                                        formControlName="question_title" [ngClass]="{
                                          'is-invalid':
                                            ques.get('question_title').touched &&
                                            ques.get('question_title').errors
                                        }" />
                                                    <button nz-button nzType="link" nzDanger
                                                        (click)="removeQuestion(i, j)">
                                                        <i nz-icon nzType="delete"></i>
                                                    </button>
                                                </div>
                                                <div *ngIf="ques.get('question_title').touched && ques.get('question_title').errors"
                                                    class="ant-form-item-explain ant-form-item-explain-error">
                                                    <div class="ant-form-item-explain-error">
                                                        <span *ngIf="ques.get('question_title').errors?.required">
                                                            This field is required
                                                        </span>
                                                        <span *ngIf="ques.get('question_title').errors?.minlength">
                                                            Minimum length is {{
                                                            ques.get('question_title').errors?.minlength.requiredLength
                                                            }}
                                                        </span>
                                                        <!-- Add other error validations as needed -->
                                                    </div>
                                                </div>
                                            </div>
                                            <span class="text-danger" *ngIf="
                                    j === quiz.get('questionnaire')['controls'].length - 1 &&
                                    questionMsg
                                  ">{{ questionMsg }}</span>
                                        </ng-container>

                                        <!-- Question List -->
                                        <ng-container *ngIf="!ques.get('is_input').value">
                                            <div class="row mb-2">
                                                <div class="col">
                                                    <div class="form-check">
                                                        <input class="form-check-input" [type]="
                                          quiz.get('questionnaireType').value === 'single'
                                            ? 'radio'
                                            : 'checkbox'
                                        " id="{{ i }}{{ j }}" [name]="quiz.get('name').value"
                                                            [checked]="ques.get('correct').value" [disabled]="false" />
                                                        <label class="form-check-label pl-2 text-capitalize"
                                                            for="{{ i }}{{ j }}">
                                                            {{ ques.get('question_title').value }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>

                                <!-- add new button -->
                                <div class="row mt-2" *ngIf="quiz.get('is_input').value">
                                    <div class="col">
                                        <a href="javascript:void(0)" class="pl-text-input"
                                            (click)="createNewQuestion(i)">Add
                                            New</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <!-- Overview -->
            <div class="overview my-4">
                <div class="row d-flex align-items-center">
                    <!-- <div class="col-lg-6 col-md-8">
                    </div> -->
                    <div class="col-lg-6 offset-lg-6 d-flex align-items-end flex-column">
                        <!-- Add New button -->
                        <div class="add-section" *ngIf="newQuiz.length === 0">
                            <span>
                                <a href="javascript:void(0)" (click)="doAddQuiz('single')"><i
                                        class="ni ni-fat-add"></i>Single
                                    Choice</a>
                                <a href="javascript:void(0)" (click)="doAddQuiz('multiple')">
                                    <i class="ni ni-fat-add"></i>Multiple Choice</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>